export default "__VITE_ASSET__6996c6e1__"